import { Urls } from 'js/src/client';
import Navigation from 'js/src/libs/navigation';

interface OpenAnimatedExplainerArgs {
    script?: string;
    aspectRatio?: string;
}

/**
 * Opens the animated explainer (GenX) app in a new tab, prefilling the script and
 * aspect ratio when available. Shared by every "start an animated explainer from this
 * content" CTA (Sketch routing, Sketch follow-on, Smart actions) so the hand-off stays
 * consistent. The params are read on the GenX side by `consumeParamsFromUrl`.
 */
export function openAnimatedExplainer({ script, aspectRatio }: OpenAnimatedExplainerArgs): void {
    const params = new URLSearchParams();
    if (script) params.set('script', script);
    if (aspectRatio) params.set('aspect_ratio', aspectRatio);

    const queryString = params.toString();
    const url = queryString ? `${Urls.ANIMATION}?${queryString}` : Urls.ANIMATION;
    Navigation.openNewTab(url);
}
